<div class="content d-flex flex-column flex-column-fluid">
    <div class="toolbar mb-5">
        <div class="container-fluid d-flex flex-stack">
            <div class="page-title d-flex flex-column align-items-start me-3 mb-5 mb-lg-0">
                <h3 class="d-flex text-dark fw-bolder fs-3 flex-column mb-0">
                    <span><i class="fas fa-user-edit text-success me-2" style="font-size: large;"></i><span></span>
                        Bilgilerimi Güncelle </span>
                </h3>
            </div>
            <div class="d-flex align-items-center gap-2 gap-lg-3">
            </div>
        </div>
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-fluid">
            <form [formGroup]="detayForm" (submit)="kaydetGuncelle()">
                <loading [loader]="yukleniyor">

                    <div class="card mb-5 col-md-8 offset-md-2 col-12" style="border-top: 4px #77c2e9 solid;">
                        <div class="card-body">
                            <div class="mb-2">
                                <div class="form-group row">
                                    <label class="col-lg-3 col-form-label text-right fs-6 text-info">Ad Soyad : </label>
                                    <div class="col-lg-6">
                                        <label class="col-form-label text-right fs-6 text-dark">{{ kullanici?.adisoyadi
                                            }}</label>
                                    </div>
                                </div>         
                                <div class="form-group row">
                                    <label class="col-md-3 col-form-label text-right fs-6 text-info">Doğum Tarihi :
                                        <span class="text-danger"> *
                                        </span></label>
                                    <div class="col-lg-9">

                                        <label class="col-form-label text-right fs-6 text-dark"
                                            *ngIf="profil[0]?.dogumTarihi">
                                            {{ profil[0]?.dogumTarihi | date:'dd.MM.yyyy'}}
                                        </label>

                                        <input type="date" name="dogumTarihi" id="dogumTarihi"
                                            formControlName="dogumTarihi" class="form-control"
                                            *ngIf="!profil[0]?.dogumTarihi" value="2022-02-02">
                                        <span class="form-text fs-6" style="color:#c96d17;border-color: #8fb9d5; text-align:right; "
                                            *ngIf="!profil[0]?.dogumTarihi"> <i
                                                class="fas fa-exclamation-triangle me-2 text-danger"></i>Merkezi Nüfus
                                            İdaresi Sisteminden kontrol edilmektedir.</span>

                                        <div class="text-danger" *ngFor="let hata of hatalar['DogumTarihi']">
                                            {{hata}}
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="form-group row">
                                    <label class="col-lg-3 col-form-label text-right fs-6 text-info">Telefon : <span
                                            class="text-danger"> *
                                        </span>
                                        <span class="badge badge-success"
                                            *ngIf="profil[0]?.telDogrulama===true; else: noCorrect">Doğrulandı</span>
                                    </label>
                                    <ng-template #noCorrect>
                                        <span class="badge badge-danger me-1" *ngIf="!profil[0]?.telefon"> Girilmedi
                                        </span>
                                        <span class="badge badge-danger"> Doğrulanmadı</span>

                                    </ng-template>

                                    <div class="col-lg-6">
                                        <input type="text" name="telefon" id="telefon" maxlength="10"
                                            formControlName="telefon" class="form-control" style="border-color: #8fb9d5;"
                                            placeholder="Lütfen telefon numaranızı giriniz." value="5555555555">
                                      
                                        <div class="text-danger" *ngFor="let hata of hatalar['Telefon']">
                                            {{hata}}
                                        </div>
                                    </div>
                                    <div class="col-lg-3"
                                        *ngIf="profil[0]?.telDogrulama!=true && profil[0]?.telefon!=null">
                                        <button type="button" (click)="smsSendModal()"
                                            class="btn btn-success btn-hover-rise" title="Sms Doğrulama Kodu Gönder"
                                            [disabled]="smsGonderimDurum"
                                            [attr.data-kt-indicator]="smsGonderimDurum ? 'on' : 'off'">
                                            <span class="indicator-label"><i class="far fa-paper-plane"></i>Kod
                                                Gönder</span>
                                            <span class="indicator-progress">Gönderiliyor...
                                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                    </div>
                                    <div class="form-group row">
                                    <div class="col-md-3"></div>
                                    <div class="col-md-9">
                                        <span class="form-text fs-6" style="color: #0095E8; text-align:right; "> <i
                                            class="fas fa-exclamation-triangle me-2 text-danger"></i>Telefon
                                        numarasını başında 0 olmadan ve boşluk bırakmadan giriniz ( Örn : 5555555555
                                        ). Bilgilerinizi <b>güncelledikten</b> sonra <b>Kod Gönder</b> butonu ile
                                        SMS doğrulaması yapmanız gerekmektedir. Telefon numarası hatalı ise SMS
                                        doğrulaması yapılamayacaktır.</span>
                                    </div>
                                </div>

                                </div>
                                <br>
                                <div class="form-group row">
                                    <label class="col-lg-3 col-form-label text-right fs-6 text-info">Kişisel E-Posta adresi
                                        :<span class="text-danger"> *
                                        </span> </label>
                                    <div class="col-lg-9">
                                        <input type="email" name="ePosta" id="ePosta" formControlName="ePosta"
                                            class="form-control" style="border-color: #8fb9d5;" placeholder="Lütfen mail adresini giriniz.">
                                        <div class="text-danger" *ngFor="let hata of hatalar['EPosta']">
                                            {{hata}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-10">
                                    <submit-button [loader]="kaydediliyor" [label]="yeni?'Kaydet':'Güncelle'"
                                        [loading]="yeni?'Kaydediliyor...':'Güncelleniyor...'">
                                    </submit-button>
                                </div>
                                <div class="col-2 text-right">
                                    <a type="reset" class="btn btn-danger btn-hover-rise" href="#" routerLink="/profil">
                                        <i class="far fa-user"></i>
                                        Bilgilerim
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </loading>
            </form>
        </div>
    </div>


    <button id="openSmsModalButton"   [hidden]="true"   data-bs-toggle="modal" data-bs-target="#sms_modal"
    data-toggle="modal">Open Modal</button>

    <form [formGroup]="smsDogrulaForm" (submit)="smsKodDogrula()">
        <div id="sms_modal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fas fa-mobile-alt text-success" style="font-size: larger; padding-right:3px;"></i>
                        <h2 class="modal-title">SMS Doğrulaması</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label class="col-lg-7 col-form-label text-right fs-6 text-info">Lütfen Cep Telefonunuza
                               <span class="fw-bolder " style="color:red;border-color: #8fb9d5;"> ({{profil[0]?.telefon}})</span> sms ile gelen doğrulama kodunu giriniz. {{sure}}</label>
                            <div class="col-lg-5">
                                <input type="text" name="dogrulamaKod" id="dogrulamaKod" maxlength="6"
                                    class="form-control" formControlName="dogrulamaKod" style="border-color: #8fb9d5;">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="text-align: center;">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i
                                class="fas fa-window-close text-info"></i>İptal</button>
                        <button type="submit" class="btn btn-success" [disabled]="dogrulaniyor"
                            [attr.data-kt-indicator]="dogrulaniyor ? 'on' : 'off'">
                            <span class="indicator-label"><i class="fas fa-check"></i>Doğrula</span>
                            <span class="indicator-progress">Doğrulanıyor..
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>